import React, { useCallback, useContext, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'antd';
import { MenuListWrapper, MenuListItem } from './styles';
import { AppStoreContext } from '../../context/appStoreContext';
import { DESIGN_ELEMENT_LAYER_DROPDOWN } from './translationValues';
import { ENTERPRISE_ENV } from '../../utils/helper';
import { useSessionContext } from '../../context/sessionContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { PageElementsContext } from '../../context/pageElementsContext';
import { useDocumentContext } from '../../context/complexDocumentContext';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';

const NAMESPACES = ['DESIGN_ELEMENT_LAYER_DROPDOWN'];
const LayerMenu = ({
  showGenerateText,
  generateTextHandler,
  showMenu,
  showMultiElementsMenu,
  elementJson,
  handleModal,
  elementId,
  element,
  showSave,
  swapElements,
  textBlock,
  setShowMenu,
  staticTable,
  enableToc,
  isHeaderElement,
  isStaticTableBlock,
  groupingElements,
  multiSelectedElementIds,
  blockId,
  enableBusinessLogic,
}) => {

  const { groupedElementIds, setGroupName } = useContext(PageElementsContext);
  const [elementType, setElementType] = useState(null);
  const [isGrouped, setIsGrouped] = useState(false);
  const [currentGroupId, setCurrentGroupId] = useState('');
  const [isBusinessLogicApplied, setIsBusinessLogicApplied] = useState(false)
  const { checkUserAccess } = useContext(AppStoreContext);
  const organisationSelector = useCallback(store => store.organisationDetails, []);
  const [ organisationDetails ] = useSessionContext(organisationSelector);
  const noVariablesDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN] || store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [disableVariables] = useArtboardContext(noVariablesDesignSelector, `ImageEditor`);

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `ComplexArtboard`);
  const artboardSelector = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [currentDesign, updateArtboard] = useArtboardContext(artboardSelector);
  const contextSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.ELEMENT_GROUPS], []);  
  const [groupingElementsMap] = useDocumentContext(contextSelector);
  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [CurrentDesign] = useArtboardContext(getCurrentDesign, 'ComplexArtboardSidebar');
  const currentGroupName = useRef();
  const [hideOptions, setHideOptions] = useState(false);

  useEffect(() => {
    let isGrouped1 = true;
    let groupID;
    const element = document.querySelector(`[data-uuid="${multiSelectedElementIds[0]}"]`);
    const group_id = element?.getAttribute('data-group-uuid');
    const groupDetail1 = groupingElementsMap.get(group_id);
    const isLogicApplied = groupDetail1?.isBLPresent;
    setIsBusinessLogicApplied(isLogicApplied);
    multiSelectedElementIds.forEach(selectedId => {
      const element1 = document.querySelector(`[data-uuid="${selectedId}"]`);
      const matchedElementGroupId = element1.getAttribute('data-group-uuid');
      if(matchedElementGroupId && matchedElementGroupId !== group_id){
        setHideOptions(true);
      }
      const groupDetail = groupingElementsMap.get(matchedElementGroupId);
      if (!matchedElementGroupId) {
        setGroupName('');
        isGrouped1 = false;
      } else if (!groupID) {
        const group_name = groupDetail?.groupName;
        setGroupName(group_name);
        currentGroupName.current = group_name;
        setCurrentGroupId(groupID);
      }
    });
    setIsGrouped(isGrouped1);
  }, []);

  useEffect(() => {
    if (showMenu && showMultiElementsMenu) {
      setElementType('multipleElements');
    } else {
      const updatedElementType =
        elementJson &&
        elementJson.elementDetails &&
        (elementJson.elementDetails.type || elementJson.elementDetails.contentType)
          ? elementJson.elementDetails.type || elementJson.elementDetails.contentType
          : elementJson?.contentType || null;
      setElementType(updatedElementType);
    }
  }, [elementJson, showMenu, showMultiElementsMenu]);

  const groupSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <circle cx="9" cy="9" r="2" />
      <circle cx="15" cy="15" r="2" />
    </svg>
  );

  const unGroupSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 4h5M15 4h5M20 9v-5M20 15v5M15 20h5M4 20h5M4 15v5M4 4v5" />
      <circle cx="8" cy="8" r="2" />
      <circle cx="16" cy="16" r="2" />
    </svg>
  );

  const businessLogicInsertSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" id="think">
      <g>
        <path d="M12.5 2C8.58 2 5.427 4.808 5.011 8.627l-1 4.771A.5.5 0 0 0 4.5 14h1.009c.159.214.322.41.491.594v.906C6 16.879 7.122 18 8.5 18H10v3.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-6.005A7.511 7.511 0 0 0 20 9.5C20 5.364 16.636 2 12.5 2zm3.714 12.83a.501.501 0 0 0-.214.41V21h-5v-3.5a.5.5 0 0 0-.5-.5h-2c-.827 0-1.5-.673-1.5-1.5v-1.105a.5.5 0 0 0-.143-.35 6.486 6.486 0 0 1-.683-.832.5.5 0 0 0-.409-.213h-.65l.882-4.216C6.364 5.433 9.099 3 12.5 3 16.084 3 19 5.916 19 9.5a6.512 6.512 0 0 1-2.786 5.33z"></path>
        <path d="M15.5 9h-.551a2.485 2.485 0 0 0-.472-1.013l.376-.376a.5.5 0 0 0-.707-.707l-.426.427a2.44 2.44 0 0 0-.72-.28V6.5a.5.5 0 0 0-1 0v.551a2.462 2.462 0 0 0-.876.365l-.512-.512a.5.5 0 0 0-.707.707l.512.512a2.495 2.495 0 0 0-.366.877H9.5a.5.5 0 0 0 0 1h.555c.092.44.3.854.611 1.188v.312a1.83 1.83 0 0 0 1.333 1.756v.244a.5.5 0 0 0 1 0v-.244a1.83 1.83 0 0 0 1.333-1.756v-.312c.311-.335.52-.748.611-1.188h.557a.5.5 0 0 0 0-1zm-2.001 1.608a.502.502 0 0 0-.166.372v.52a.826.826 0 0 1-.433.717c-.089-.128-.231-.217-.4-.217s-.311.089-.401.217a.828.828 0 0 1-.433-.717v-.52a.499.499 0 0 0-.166-.372c-.322-.29-.5-.683-.5-1.108 0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .425-.178.818-.501 1.108z"></path>
      </g>
    </svg>
  );

  const onSave = (referenced = false) => {
    handleModal({
      id: elementId,
      target: element,
      elementType,
      elementJson,
      referenced,
    });
  };

  const handleClick = (type, elementId, showGroupNameModal = true) => {
    const blockElement = document.getElementById(blockId)
    if (CurrentDesign === 'document') {
      if (showGroupNameModal) {
        if (currentGroupId && !isGrouped) {
          updateArtboard({
            [CONTEXT_KEYS.GROUP_NAME_MODAL]: false,
            [CONTEXT_KEYS.GROUP_ACTION_ITEM]: type,
          });
          groupingElements('Group', groupedElementIds, currentGroupName.current);
        }
        else {
          updateArtboard({
            [CONTEXT_KEYS.GROUP_NAME_MODAL]: type === 'Group' ? true : false,
            [CONTEXT_KEYS.GROUP_ACTION_ITEM]: type,
          });
        }
      }
      else {
        updateArtboard({
          [CONTEXT_KEYS.GROUP_NAME_MODAL]: false
        });
        groupingElements('Group', groupedElementIds, '');
      }
      if (type === 'UnGroup') {
        blockElement.dispatchEvent(
          new CustomEvent('removeHighlight',{ detail: {}}),
        );
        setGroupName('')
        groupingElements(type, groupedElementIds, '');
      }
    }
    else if( CurrentDesign === 'block' || CurrentDesign === 'flow') {
      updateArtboard({
        [CONTEXT_KEYS.GROUP_NAME_MODAL]: false,
        [CONTEXT_KEYS.GROUP_ACTION_ITEM]: type,
      });
      groupingElements(type, groupedElementIds, '');
      if (type === 'UnGroup') {
        blockElement.dispatchEvent(
          new CustomEvent('removeHighlight', { detail: {} }),
        );
        setGroupName('')
        groupingElements(type, groupedElementIds, '');
      }
    }
  }

  const handleBusinessLogicClick = (type,elementId) => {
    enableBusinessLogic();
  }
  

  const { t } = useTranslation(NAMESPACES);
  return (
    <>
      {
        <MenuListWrapper
          style={{
            display:
              showMenu && showMultiElementsMenu && !showSave && groupedElementIds?.length === 0
                ? 'none'
                :(groupedElementIds?.length > 1 && (isInteractiveDesign)) ? 'none' : hideOptions ? 'none':'block',
          }}
        >
          <div id="extraMenuItems" />
          {showMenu && !showMultiElementsMenu && groupedElementIds?.length <= 1 && !textBlock && !staticTable && (
            <>
              {/* {!isHeaderElement &&
            <MenuListItem
            id="addToToc"
              onClick={enableToc}
              disabled={!showGenerateText}
            >
              <Icon type="profile" />            
              {t(DESIGN_ELEMENT_LAYER_DROPDOWN.ADD_TO_TOC.key, DESIGN_ELEMENT_LAYER_DROPDOWN.ADD_TO_TOC.value)}
            </MenuListItem>
          } */}
              <MenuListItem onClick={e => swapElements('sendBackward', elementId)}>
                <Icon type="step-backward" />
                {t(
                  DESIGN_ELEMENT_LAYER_DROPDOWN.SEND_ELEMENT_BACKWARD_OPTION.key,
                  DESIGN_ELEMENT_LAYER_DROPDOWN.SEND_ELEMENT_BACKWARD_OPTION.value,
                )}
              </MenuListItem>
              <MenuListItem onClick={() => swapElements('sendToBack', elementId)}>
                <Icon type="fast-backward" />
                {t(
                  DESIGN_ELEMENT_LAYER_DROPDOWN.SEND_ELEMENT_TO_BACK_OPTION.key,
                  DESIGN_ELEMENT_LAYER_DROPDOWN.SEND_ELEMENT_TO_BACK_OPTION.value,
                )}
              </MenuListItem>
              <MenuListItem onClick={() => swapElements('bringForward', elementId)}>
                <Icon type="step-forward" />
                {t(
                  DESIGN_ELEMENT_LAYER_DROPDOWN.BRING_ELEMENT_FORWARD_OPTION.key,
                  DESIGN_ELEMENT_LAYER_DROPDOWN.BRING_ELEMENT_FORWARD_OPTION.value,
                )}
              </MenuListItem>
              <MenuListItem onClick={() => swapElements('bringToFront', elementId)}>
                <Icon type="fast-forward" />
                {t(
                  DESIGN_ELEMENT_LAYER_DROPDOWN.BRING_ELEMENT_TO_FRONT_OPTION.key,
                  DESIGN_ELEMENT_LAYER_DROPDOWN.BRING_ELEMENT_TO_FRONT_OPTION.value,
                )}
              </MenuListItem>
            </>
          )}
          {!disableVariables && showMenu && !textBlock && !staticTable && groupedElementIds?.length > 0 ? (
            <>
              {groupedElementIds?.length > 1 && <MenuListItem onClick={() => { handleClick(isGrouped ? 'UnGroup' : 'Group', groupedElementIds) }}>
                <Icon component={isGrouped ? unGroupSvg : groupSvg} />
                {isGrouped ?
                  t(
                    DESIGN_ELEMENT_LAYER_DROPDOWN.UN_GROUPING.key,
                    DESIGN_ELEMENT_LAYER_DROPDOWN.UN_GROUPING.value,
                  )
                  :
                  t(
                    DESIGN_ELEMENT_LAYER_DROPDOWN.GROUPING.key,
                    DESIGN_ELEMENT_LAYER_DROPDOWN.GROUPING.value,
                  )
                }
              </MenuListItem>}
             {CurrentDesign === 'document' && !showGenerateText && !disableVariables && !isBusinessLogicApplied && <MenuListItem onClick={()=>{handleBusinessLogicClick('Group', groupedElementIds)}}>
            <Icon component={businessLogicInsertSvg} />            
                {t(
                  DESIGN_ELEMENT_LAYER_DROPDOWN.ADD_BUSINESS_LOGIC.key,
                  DESIGN_ELEMENT_LAYER_DROPDOWN.ADD_BUSINESS_LOGIC.value,
                )}
          </MenuListItem>}
            </>
          ) : null}
          {!['table', 'referenced'].includes(elementType) &&
            showSave &&
            !textBlock &&
            !staticTable && (
              <>
                {showMenu && !showMultiElementsMenu && <hr className="list-break" />}
                <MenuListItem onClick={() => onSave(false)}>
                  <Icon type="save" />
                  {t(
                    DESIGN_ELEMENT_LAYER_DROPDOWN.SAVE_AS_REUSABLE_ASSET_OPTION.key,
                    DESIGN_ELEMENT_LAYER_DROPDOWN.SAVE_AS_REUSABLE_ASSET_OPTION.value,
                  )}
                </MenuListItem>
                {checkUserAccess('client') && (
                  <MenuListItem onClick={() => onSave(true)}>
                    <Icon type="save" />
                    {t(
                      DESIGN_ELEMENT_LAYER_DROPDOWN.SAVE_AS_REFERENCED_ASSET_OPTION.key,
                      DESIGN_ELEMENT_LAYER_DROPDOWN.SAVE_AS_REFERENCED_ASSET_OPTION.value,
                    )}
                  </MenuListItem>
                )}
              </>
            )}
          {(elementType === 'text' || textBlock || isStaticTableBlock) && (
            <>
              {!isHeaderElement && !disableVariables ? (
                <MenuListItem id="addToToc" onClick={enableToc} disabled={!showGenerateText}>
                  <Icon type="profile" />
                  {t(
                    DESIGN_ELEMENT_LAYER_DROPDOWN.ADD_TO_TOC.key,
                    DESIGN_ELEMENT_LAYER_DROPDOWN.ADD_TO_TOC.value,
                  )}
                </MenuListItem>
              ) : null}
              {!textBlock && !isStaticTableBlock && <hr className="list-break" />}
              {!isStaticTableBlock &&
              (ENTERPRISE_ENV && organisationDetails ? organisationDetails.aiWriting : true) ? (
                <MenuListItem
                  id="writeForMe"
                  onClick={() => {
                    if (generateTextHandler) {
                      generateTextHandler();

                      if (textBlock) {
                        setShowMenu(false);
                      }
                    }
                  }}
                  disabled={!showGenerateText}
                >
                  <Icon type="edit" />
                  {t(
                    DESIGN_ELEMENT_LAYER_DROPDOWN.AI_AUTO_FILL_CONTENT_WRITE_FOR_ME_OPTION.key,
                    DESIGN_ELEMENT_LAYER_DROPDOWN.AI_AUTO_FILL_CONTENT_WRITE_FOR_ME_OPTION.value,
                  )}
                </MenuListItem>
              ) : null}
            </>
          )}
        </MenuListWrapper>
      }
    </>
  );
};

export default LayerMenu;
